var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubInCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9.28027 6V11.2002H8V12.6719H9.28027V13.6162H8V15.1035H9.28027V17.4561H11.5195V15.1035H14.6719V13.6162H11.5195V12.6719H12.3838C13.1518 12.6719 13.8402 12.5649 14.4482 12.3516C15.0561 12.1276 15.5308 11.7758 15.8721 11.2959C16.224 10.8052 16.4004 10.1653 16.4004 9.37598C16.4004 8.7894 16.3042 8.28803 16.1123 7.87207C15.9204 7.44555 15.6428 7.0937 15.2803 6.81641C14.9283 6.53911 14.5121 6.33601 14.0322 6.20801C13.5522 6.06934 13.0183 6 12.4316 6H9.28027ZM12.4316 7.77637C12.8154 7.77637 13.1357 7.82902 13.3916 7.93555C13.6583 8.04221 13.8564 8.21853 13.9844 8.46387C14.123 8.69853 14.1924 9.01357 14.1924 9.4082C14.1924 9.81345 14.1171 10.1494 13.9678 10.416C13.8292 10.6825 13.6268 10.8798 13.3604 11.0078C13.0938 11.1358 12.7736 11.2002 12.4004 11.2002H11.5195V7.77637H12.4316Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubInCircleFilled);
export default __webpack_public_path__ + "static/media/rubInCircleFilled.0ad78707d9395e159d5b53cd1e69230a.svg";
export { ForwardRef as ReactComponent };